import React, { Fragment } from 'react';
import get from 'lodash/get';

import handleExpirationTime from '../handleExpirationTime';
import { SURVEYS_STATUS_TYPE } from '../../constants';
import { COLORS } from '../../constants/styles';

export default (survey, formatMessage, showStatus = true) => {
  const {
    expiredAt,
    status,
    userAppointment,
    survey: { dueDescription },
  } = survey;
  const dateTime = get(userAppointment, 'dateTime');
  const expirationTime = expiredAt || dateTime;

  let expiredAtMessage = '';
  let statusMessage = '';

  if (expirationTime) {
    expiredAtMessage = handleExpirationTime(expirationTime, false);
  }

  if (dueDescription) {
    expiredAtMessage = dueDescription;
  }

  if (status === SURVEYS_STATUS_TYPE.STARTED) {
    statusMessage = formatMessage({ id: 'surveys.isStarted' }).toLowerCase();
  }
  if (status === SURVEYS_STATUS_TYPE.IN_PROGRESS) {
    statusMessage = formatMessage({ id: 'surveys.inProgress' }).toLowerCase();
  }
  return (
    <Fragment>
      {statusMessage && showStatus && (
        <span
          style={{
            color: COLORS.blueAccentPlus,
          }}
        >
          {statusMessage}
        </span>
      )}
      {expiredAtMessage && <span>{expiredAtMessage}</span>}
    </Fragment>
  );
};



// WEBPACK FOOTER //
// ./src/utils/survey/getStatus.js